import { render, staticRenderFns } from "./SrSwitch.vue?vue&type=template&id=ac115ddc"
import script from "./SrSwitch.vue?vue&type=script&lang=js"
export * from "./SrSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports